import {
  REGENERATE_TOKEN_SUCCESS,
  REGENERATE_TOKEN_FAILED,
  RESET_REGENERATE_TOKEN,
  LOADING_REGENERATE_TOKEN,
  NETWORK_ERROR_REGENERATE_TOKEN
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetRegenerateToken = () => {
  return { type: RESET_REGENERATE_TOKEN };
};

const getRegenerateToken = (userData, options = {}) => async (dispatch) => {
  const requestData = {
    ...userData,
    authToken: sessionStorage.getItem("authToken") || userData.authToken,
  };

  dispatch({ type: LOADING_REGENERATE_TOKEN });
  return partnerServices
    .post("regenerateToken", requestData, { skipAuthRefresh: true })
    .then((res) => {
      switch (res.data.status) {
        case "success":
          dispatch(regenerateTokensuccess(res.data));
          // console.log("regenerateTokenres reponse", res.data);
          // console.log("authToken after regenerate 3456 , ",res.data.AuthToken);
          break;
        default:
          dispatch(regenerateTokenfailed(res.data));
          break;
      }

      return res.data;
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_REGENERATE_TOKEN, payload: err });
      if (options.throwOnError) {
        throw err;
      }

      return err?.response?.data;
    });
};
function regenerateTokensuccess(data) {

  sessionStorage.setItem("authToken", data.AuthToken);
  return {
    type: REGENERATE_TOKEN_SUCCESS,
    payload: data

  };

}
function regenerateTokenfailed(data) {
  return {
    type: REGENERATE_TOKEN_FAILED,
    payload: data
  };
}

export { getRegenerateToken, resetRegenerateToken };